export const mapNumberPropResponsive = (
  prop:
    | string
    | number
    | (string | number | null)[]
    | { [key: string]: string | number | null },
  lambdaNumberFn: (n: number) => string | number = (n) => n,
  lambdaStringFn: (s: string) => string | number = (s) => s,
) => {
  if (typeof prop === "number") {
    return lambdaNumberFn(prop)
  }
  if (typeof prop === "string") {
    return lambdaStringFn(prop)
  }
  if (Array.isArray(prop)) {
    return prop.map((p) =>
      typeof p === "number"
        ? lambdaNumberFn(p)
        : typeof p === "string"
        ? lambdaStringFn(p)
        : p,
    )
  }
  if (typeof prop === "object") {
    return Object.fromEntries(
      Object.entries(prop).map(([key, value]) => [
        key,
        typeof value === "number"
          ? lambdaNumberFn(value)
          : typeof value === "string"
          ? lambdaStringFn(value)
          : value,
      ]),
    )
  }
  return prop
}

export default mapNumberPropResponsive
